import React, { Fragment } from 'react';
import { Header, Tab } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import XTab from '../../common/tabs/XTab';
import FeeRebateContainer from './FeeRebateContainer';
import GeneralJournalContainer from './GeneralJournalContainer';
import BalanceAdjustmentContainer from './BalanceAdjustmentContainer';
import ClosingPricesContainer from './ClosingPricesContainer';
import TradeEntryContainer from './TradeEntryContainer';
import BankCommunicationContainer from './BankCommunicationContainer';
import AddCollateralContainer from './AddCollateralContainer';
import DesignationTransferContainer from './DesignationTransferContainer';
import ExternalTransferContainer from './ExternalTransferContainer';
import { getEnv } from '../../reducers/envReducer';
import FundingRates from './FundingRates';
import { roles } from 'constants/userRoles';
import { getUserHasAnyRole } from 'reducers/usersReducer';

export const READ_ONLY_ROLES_FOR_MANUAL_ENTRY = [roles.RISK];
const mapStateToProps = (state) => ({
  env: getEnv(state),
  isReadOnlyRole: getUserHasAnyRole(state, READ_ONLY_ROLES_FOR_MANUAL_ENTRY),
});

const panes = (env, isReadOnlyRole) => [
  {
    menuItem: 'Closing Prices',
    url: 'closing_prices',
    render: () => (
      <Tab.Pane attached={false}>
        <ClosingPricesContainer />
      </Tab.Pane>
    ),
  },
  {
    menuItem: 'Funding Rates',
    url: 'funding_rates',
    render: () => (
      <Tab.Pane attached={false}>
        <FundingRates />
      </Tab.Pane>
    ),
  },
  {
    url: 'fee_rebate',
    menuItem: 'Fee Rebate',
    show: !isReadOnlyRole,
    render: () => (
      <Tab.Pane attached={false}>
        <FeeRebateContainer />
      </Tab.Pane>
    ),
  },
  {
    url: 'trade_entry',
    menuItem: 'Trade Entry',
    show: !isReadOnlyRole,
    render: () => (
      <Tab.Pane attached={false}>
        <TradeEntryContainer />
      </Tab.Pane>
    ),
  },
  {
    url: 'bank_communication',
    menuItem: 'Bank Communication',
    render: () => (
      <Tab.Pane attached={false}>
        <BankCommunicationContainer />
      </Tab.Pane>
    ),
  },
  {
    url: 'tme_adjustment',
    menuItem: 'TME Adjustment',
    render: () => (
      <Tab.Pane attached={false}>
        <BalanceAdjustmentContainer />
      </Tab.Pane>
    ),
  },
  {
    url: 'general_journal',
    menuItem: 'General Journal',
    show: !isReadOnlyRole,
    render: () => (
      <Tab.Pane attached={false}>
        <GeneralJournalContainer />
      </Tab.Pane>
    ),
  },
  {
    url: 'designation_transfer',
    menuItem: 'Designated Funds Transfer',
    render: () => (
      <Tab.Pane attached={false}>
        <DesignationTransferContainer />
      </Tab.Pane>
    ),
    // temporarily hiding this tab per product team request
    show: false,
  },
  {
    url: 'add_collateral',
    menuItem: 'Collateral',
    render: () => (
      <Tab.Pane attached={false}>
        <AddCollateralContainer />
      </Tab.Pane>
    ),
    show: !isReadOnlyRole && env.enableAddCollateralView === 'true',
  },
  {
    url: 'external_transfer',
    menuItem: 'External Transfer',
    show: !isReadOnlyRole,
    render: () => (
      <Tab.Pane attached={false}>
        <ExternalTransferContainer />
      </Tab.Pane>
    ),
  },
];

const ManualEntryContainer = ({ env = {}, isReadOnlyRole }) => (
  <Fragment>
    <Header as="h1">Manual Entry</Header>
    <XTab panes={panes(env, isReadOnlyRole)} authorize />
  </Fragment>
);

ManualEntryContainer.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export default connect(mapStateToProps, null)(ManualEntryContainer);
